import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    meetcontext: null
  },
  mutations: {
    SET_MEETCONTEXT (store, value) {
      store.meetcontext = value
    }
  },
  getters: {
    meetcontext: (store, getters) => {
      return store.meetcontext
    }
  },
  actions: {
    getMeetcontext ({commit}, data) {
      return axios
      .get(`/meet-context/${data.token}`, {
        skipErrorRedirect: true
      })
      .then((response) => {
        const result = {
          token: data.token,
          ...response.data
        }
        commit('SET_MEETCONTEXT', result)
        return result
      })
    },
    resetMeetcontext ({commit}) {
      commit('SET_MEETCONTEXT', null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Meetcontext.js